import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
} from '@core/state/entities/entity.helpers';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';
import { IDataExportJob } from '@core/state/entities/data-export-job/data-export-job.entity';
import {
  dataExportJobSubscriptionActions,
  dataExportServiceActions,
} from '@core/state/ui/data-export/data-export.actions';

export const dataExportJobReducer = createReducer(
  defaultEntityState<IDataExportJob>(),

  on(
    dataExportServiceActions.dataExportJobCreated,
    dataExportJobSubscriptionActions.dataExportJobUpdate,
    (state, props) =>
      mergeEntityState(
        entityKey.dataExportJobs,
        state,
        props,
        (dej) => dej.id === props.jobId
      )
  )
);
